var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgTonkeyLogo = function SvgTonkeyLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9995 39.9989L0 9.99973L9.99982 1.89248e-06L29.9995 19.9995L49.9991 0L59.9989 9.99973L29.9995 39.9989Z",
    fill: "#B2D4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9995 0.000976562L0 30.0002L9.99982 39.9999L29.9995 20.0004L49.9991 39.9999L59.9989 30.0002L29.9995 0.000976562Z",
    fill: "#B2D4FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 29.9997L49.9998 20L59.9996 29.9997L49.9998 39.9995L40 29.9997Z",
    fill: "url(#paint0_linear_1_210)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0003558 9.99978L10.0002 4.85579e-05L20 9.99978L10.0002 19.9995L0.0003558 9.99978Z",
    fill: "url(#paint1_linear_1_210)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 10.0003L30.0003 20L20.0005 10.0003L30.0003 0.000577052L40.0001 10.0003Z",
    fill: "url(#paint2_linear_1_210)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9977 29.9992L29.9979 39.999L19.998 29.9992L29.9979 19.9995L39.9977 29.9992Z",
    fill: "url(#paint3_linear_1_210)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_210",
    x1: 39.9978,
    y1: 29.9994,
    x2: 60,
    y2: 29.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_210",
    x1: 20.0022,
    y1: 10.0001,
    x2: 4.89982e-7,
    y2: 10.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_210",
    x1: 40.0023,
    y1: 10.0007,
    x2: 30.0023,
    y2: 10.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_210",
    x1: 19.9959,
    y1: 29.9989,
    x2: 29.9959,
    y2: 29.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D4FC"
  })))));
};
export default SvgTonkeyLogo;